import { APIFactory } from '../api/api.factory'
const GroundTransportationAPI = APIFactory.get('groundTransportation')

export default {
    async getGroundTransportation(erID) {
        const { data } = await GroundTransportationAPI.getGroundTransportation(erID)
        return data;
    },
    async getGroundTransportationTypes() {
        const { data } = await GroundTransportationAPI.getGroundTransportationTypes()
        return data;
    },
    async getMileageRates() {
        const { data } = await GroundTransportationAPI.getMileageRates()
        return data;
    }
}